<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox hide" v-if="is_hearing==1">
        <div class="btnBox">
          <button class="btn btn-search">单题</button>
          <button class="btn btn-reset">多题</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>题库列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="lookImg">查看案例图</button>
            <button class="btn btn-add" @click="lookAudio" v-if="is_hearing==1">查看音频</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.que_num">{{item.que_num}}</p>
              <p class="topic_title" :title="item.topic_title">{{item.topic_title}}</p>
              <p :title="item.answer">{{item.answer}}</p>
              <p :title="item.prompt">{{item.prompt}}</p>
              <div class="topic_content" v-html="item.content" v-if="is_hearing==0"></div>
              <p :ttile="item.content" v-else>{{item.content}}</p>
              <p style="color:#FF7543;">
                  <span @click="editShow(item)">编辑</span>
                  <span @click="removeSub(item)">删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox buildBox" v-if="showType">
      <div class="contv">
        <p class="title">编辑题目</p>
        <form>
          <div class="write-txt">
            <p>题号：</p>
            <input type="text" v-model="addObj.que_num">
          </div>
          <div class="write-txt">
            <p>题干：</p>
            <input type="text" v-model="addObj.topic_title">
          </div>
          <div class="write-txt">
            <p>选项A：</p>
            <input type="text" v-model="addObj.option_A">
          </div>
          <div class="write-txt">
            <p>选项B：</p>
            <input type="text" v-model="addObj.option_B">
          </div>
          <div class="write-txt">
            <p>选项C：</p>
            <input type="text" v-model="addObj.option_C">
          </div>
          <div class="write-txt">
            <p>选项D：</p>
            <input type="text" v-model="addObj.option_D">
          </div>
          <div class="write-txt ">
            <p>{{is_hearing==1?'听力文本':'素材'}}：</p>
            <myEditor v-if="is_hearing==0" class="write-content" @input="sourceInput" @imgUpload="imgUpload" :value="addObj.content" :index="1" @click="sourceClick(index)"/>
            <textarea v-else v-model="addObj.content"></textarea>
          </div>
          <div class="write-txt">
            <p>提示语：</p>
            <input type="text" v-model="addObj.prompt">
          </div>
          <div class="write-txt">
            <p>答案：</p>
            <input type="text" v-model="addObj.answer">
          </div>
          <div class="write-txt">
            <p>解析：</p>
            <input type="text" v-model="addObj.analysis">
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <!-- 音频 -->
    <div class="msgBox tipsBox uploadBox" v-if="audioType">
      <div class="contv">
        <p class="title">请上传音频</p>
        <form>
          <div class="form-txt">
              <div class="txt">
                <div class="upload">
                  <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :limit=1
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <audio :src="'https://pic.bi-rong.com/'+uploadUrl" controls v-if="uploadUrl"></audio>
                </div>
              </div>
            </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-sub" @click="">确认</button> -->
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

    <!-- 案例 -->
    <div class="msgBox tipsBox uploadBox" v-if="directionsType">
      <div class="contv">
        <p class="title">请上传案例</p>
        <form>
          <div class="form-txt">
              <div class="txt">
                <div class="img" @mouseenter="imgShow('ExerSet')" @mouseleave="imgHide('ExerSet')">
                  <img :src="'https://pic.bi-rong.com/'+uploadUrl" alt="">
                  <div class="hover" v-if="imgType">
                    <i class="el-icon-delete" @click="imgRemove('ExerSet')"></i>
                  </div>
                </div>
                <div class="upload">
                  <el-upload
                    :action="url+'/ent/Upload/uploadFile'"
                    list-type="picture-card"
                    :on-preview="handlePictureCardPreview"
                    :on-success="handleSuccess"
                    :limit=1
                    :on-remove="handleRemove">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="'https://pic.bi-rong.com/'+uploadUrl" alt="">
                  </el-dialog>
                </div>
              </div>
            </div>
        </form>
        <div class="btnBox">
          <!-- <button class="btn btn-sub" @click="">确认</button> -->
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>

  </div>

  
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import myEditor from './../components/comment/wangeditor.vue'
import { lookTopicList ,editSmallTopic,delTopics,editBigTopic} from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'1',
      childrenID:'1-2',
      titleList:[
        {id:1,title:'序号'},
        {id:6,title:'题号'},
        {id:3,title:'题干'},
        {id:4,title:'答案'},
        {id:2,title:'素材'},
        {id:5,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        tid:'',
        model_id:''
      },
      addObj:{
        small_topic_id:'',
        model_id:'',
        que_num:'',
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
      uploadUrl:'',
      dialogVisible:false,
      directionsType:false,
      imgUrl:'',
      audioUrl:'',
      audioType:false,
      url:'',
      is_hearing:0,
    };
  },
  components: {
    navBox,
    myHeader,
    myEditor
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.url = this.$refs.navBox.url;
    this.obj.tid = this.$route.query.tid;
    this.obj.model_id = this.addObj.model_id = this.$route.query.model_id;
    this.is_hearing = this.$route.query.is_hearing;
    if(this.is_hearing == 1){
      this.titleList=[
        {id:1,title:'序号'},
        {id:6,title:'题号'},
        {id:3,title:'题干'},
        {id:4,title:'答案'},
        {id:7,title:'提示词'},
        {id:2,title:'听力文本'},
        {id:5,title:'操作'},
      ]
    } else {
      this.titleList=[
        {id:1,title:'序号'},
        {id:6,title:'题号'},
        {id:3,title:'题干'},
        {id:4,title:'答案'},
        {id:7,title:'提示词'},
        {id:2,title:'素材'},
        {id:5,title:'操作'},
      ]
    }
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      var that = this;
      this.directionsType = false;
      this.audioType = false;
      this.showType = '';
      this.addObj={
        small_topic_id:'',
        model_id:that.$route.query.model_id,
        que_num:'',
      }
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      editSmallTopic(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      var that = this;
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.dataList = [];
      this.addObj={
        small_topic_id:'',
        model_id:that.$route.query.model_id,
        que_num:'',
      };
      this.getList();
    },

    getList(){
      var that = this;
      lookTopicList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
          that.imgUrl = data.data.directions;
          that.audioUrl = data.data.video;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.addObj.name = '';
    },

    editShow(e){
      this.showType = 'edit';
      this.addObj.small_topic_id = e.small_topic_id;
      this.addObj.que_num = e.que_num;
      this.addObj.topic_title = e.topic_title;
      this.addObj.answer = e.answer;
      this.addObj.option_A = e.option_A;
      this.addObj.option_B = e.option_B;
      this.addObj.option_C = e.option_C;
      this.addObj.option_D = e.option_D;
      this.addObj.big_topic_id = e.big_topic_id;
      if(e.content){
        this.addObj.content = e.content;
      };
      if(e.prompt){
        this.addObj.prompt = e.prompt;
      } 
      if(e.analysis){
        this.addObj.analysis = e.analysis;
      } 
      console.log(this.addObj,'==addObj==')
    },

    switchChange(e){
      var that = this;
      var obj = {
        mtid:e.mtid,
        status:e.publish_status==false?0:1,
      };
      publishMockTest(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(e){
      var that = this;
      console.log(e.mtid)
      that.$router.push('/pack?id='+e.mtid);
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.uploadUrl = '';
    },

    handleRemove(file, fileList) {
      console.log(file, fileList,'remove');
      this.uploadUrl = '';
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(response, file, fileList){
      this.uploadUrl = response.data.src;
      console.log(this.uploadUrl,'==this.uploadUrl==')
    },

    lookImg(){
      this.directionsType = true;
      this.uploadUrl = this.imgUrl;
    },

    lookAudio(){
      this.audioType = true;
      this.uploadUrl = this.audioUrl;
    },

    removeSub(e){
      var that = this;
      delTopics({small_topic_id:e.small_topic_id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.resetSub();
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },


    sourceClick(i){
      console.log(i,'==i==')
    },

    sourceInput(value,index) {
      // this.addObj.topics[index].content = value;
      console.log('value',value)
      this.addObj.content = value;
    },

    imgUpload(type){
      console.log(type,'==type==')
    }
  },
};
</script>
<style scoped>
.dataList .listItem .topic_content,
.dataList .listItem .topic_title,
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 7 );
  word-break: break-word;
}

.dataList .listItem .topic_content {
  display: inline-block;
  padding: 21px 0;
  word-break: break-word;
}

.dataList .listItem .topic_content >>> p{
  padding: 0!important;
  width: 100%;
}

.dataList .listItem .topic_content >>> p img{
  width: 100%;
}

.tipsBox form .write-txt textarea,
.tipsBox form .write-txt input{
  width: 500px;
}
.tipsBox form .write-txt textarea{
  font-size: 15px;
  color: #3D3D3D;
  background-color: #F4F5F8;
  border-radius: 10px;
  height: 200px;
  box-sizing: border-box;
  padding: 10px 20px;
}

.tipsBox.uploadBox .txt{
  height: auto;
  line-height: auto;
}

.tipsBox.uploadBox .txt .img{
  width: 200px;
  display: block;
  margin: 0 auto;
}

.tipsBox.uploadBox .txt .img img{
  width: 100%;
}

.tipsBox form .write-content {
  text-align: left;
  display: inline-block;
  vertical-align: top;
  width: 500px;
}

.tipsBox form .write-content >>> .editor-cont{
  height: 200px!important;
  width: 100%;
}

.tipsBox form .write-content >>> p{
  display: block;
  width: auto;
  margin: 0;
  line-height: auto;
  height: auto;
  word-break: break-word;
}

.tipsBox form .write-content >>> .w-e-text-container,
.tipsBox form .write-content >>> .w-e-text-container .w-e-scroll,
.tipsBox form .write-content >>> .w-e-text-container{
  width: 100%;
}

.buildBox .contv{
  height: 80%;
}

.buildBox .contv form{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/exam/bank.vue